import React, { useState } from "react";
import { Form, Container } from "react-bootstrap";
import Select from "react-select";
import {
  faCamera,
  faFileVideo,
  faCloudUploadAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Self_Service_Change_Password.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";

function Self_Service_Change_Password() {
  const options = [{ value: "wrong_name", label: "Wrong beneficiary name" }];

  const [previews, setPreviews] = useState({
    id_card: null,
    new_id_card: null,
    old_passbook: null,
    new_passbook: null,
    latest_deposit_1: null,
    latest_deposit_2: null,
    pdf_file: null,
    video_holding: null,
  });

  const handleImageChange = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      // Create preview only if it's an image; otherwise, just store the file name or a placeholder
      setPreviews((prev) => ({
        ...prev,
        [key]: file.type.startsWith("image")
          ? URL.createObjectURL(file)
          : "file_uploaded",
      }));
    }
  };

  const uploadFields = [
    { id: "id_card", label: "Deposit proof receipt detail", mandatory: true },
  ];

  return (
    <>
      <section className="Modify_Bank_Information Deposit_Not_Received_Form Self_Service_Change_Password">
        <Common_white_header headingText={"Self Service Change Password"} />
        <Container>
          <Form>
            <Form.Group className="form-group field_holder">
              <Form.Label>
                New Password <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                disabled
                type="number"
                placeholder="Enter New Password"
              />
            </Form.Group>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                Register phone number to receive OTP{" "}
                <span className="mandatory_estrics">*</span>
              </Form.Label>
              <div className="input_holder">
                <Form.Control
                  type="number"
                  placeholder="Please Enter Email"
                />
                <div className="float_btn_holder">
                  <button className="blue_primary_btn" >Send Verification Code</button>
                </div>
              </div>
            </Form.Group>

            <button type="submit" className="btn_register_bg">
              Confirm
            </button>
          </Form>
        </Container>
      </section>
    </>
  );
}

export default Self_Service_Change_Password;
